import { adminApiFetch } from './apiService';

export const userInvitationService = {
  // 列表
  fetchList: async (merchantId = null) => {
    const url = merchantId ? `merchants/${merchantId}/user_invitations` : 'user_invitations';
    const response = await adminApiFetch(url, { method: 'GET' });
    return response.json();
  },

  // 創建
  create: async (merchantId, data) => {
    const url = merchantId ? `merchants/${merchantId}/user_invitations` : 'user_invitations';
    const response = await adminApiFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // 重新發送
  regenerate: async (merchantId, id) => {
    // Admin 的 API 可能不包含 merchantId 路徑，或者包含
    // 假設 Admin 是 `user_invitations/:id/regenerate`
    const url = merchantId
      ? `merchants/${merchantId}/user_invitations/${id}/regenerate`
      : `user_invitations/${id}/regenerate`;

    const response = await adminApiFetch(url, {
      method: 'POST',
    });
    return response.json();
  },

  // 刪除
  delete: async (merchantId, id) => {
    const url = merchantId
      ? `merchants/${merchantId}/user_invitations/${id}`
      : `user_invitations/${id}`;

    const response = await adminApiFetch(url, {
      method: 'DELETE',
    });
    return response.json();
  },
};

export default userInvitationService;
